<template>
  <div class="big">
    <div class="bar">
      <span class="clock">{{ date.time }}</span
      ><span class="date">星期{{ date.tile }}<br />{{ date.day }}</span>
    </div>
    <div class="box">
      <div class="banner">
        <Banner />
      </div>
      <div class="rolling">
        <h2>当前抽奖码数量</h2>
        <RolingText v-model="count" :time="1" />
      </div>
      <div class="gift">
        <Gift />
      </div>
    </div>
  </div>
</template>

<script>
import RolingText from "./components/RolingText.vue";
import Banner from "./components/Banner.vue";
import Gift from "./components/Gift.vue";
import dayjs from "dayjs";
import { lotteryUserGetCurrentUserCount } from "@/api/index";

export default {
  components: {
    RolingText,
    Banner,
    Gift,
  },
  data() {
    return {
      count: 0,
      lotteryId: "1683689464171335681",
      date: {
        time: new Date(),
        day: "",
        tile: "",
      },
    };
  },
  created() {
    if (this.$route.query.lotteryId) {
      this.lotteryId = this.$route.query.lotteryId;
    }
    this.getRotteryCount();
  },
  mounted() {
    document.title = "慕思数据大屏展示";
    const tileArr = ["日", "一", "二", "三", "四", "五", "六"];
    setInterval(() => {
      const now = new Date();
      this.date.time = dayjs(now).format("HH:mm:ss");
      this.date.day = dayjs(now).format("YYYY.MM.DD");
      this.date.tile = tileArr[dayjs(now).day()];
    }, 1000);
    setInterval(() => {
      // this.count += Math.round(Math.random() * 10000);
      this.getRotteryCount();
    }, 1000 * 10);
  },
  methods: {
    getRotteryCount() {
      lotteryUserGetCurrentUserCount({ lotteryId: this.lotteryId }).then(
        (res) => {
          this.count = res?.data;
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
/* prettier-ignore */
.big {
  width: 1920PX;
  height: 1080PX;
  background: url(https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230728/ODE4JUU1JUE0JUE3JUU1JUIxJThGMjMwNzI1MTEuMTY5MDUwODYwNTYwNQ==.jpg)
    center center no-repeat;
  background-size: 100% 100%;
  .box{
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .bar{
    display: flex;
    justify-content: flex-end;
    height: 125PX;
    margin-right: 81PX;
    .clock{
      color: #fff;
      font-size: 45PX;
      line-height: 2.4;
      width: 235PX;
      text-align: center;
      overflow: hidden;
    }
    .date{
      color: #fff;
      font-size: 18PX;
      margin-top: 33PX;
      // margin-left: 19PX;
      color: #9DCDFF;
    }
  }
  .banner{
    width: 490PX;
    height: 903PX;
    background: url(https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230726/bGVmdC4xNjkwMzQ0ODYxMTMw.png) center center no-repeat;
    background-size: 100% 100%;
    overflow: hidden;
  }
  .gift{
    width:498PX;
    height: 893PX;
    background: url(https://derucci-app-obs.iderucci.com/consumer-admin-derucci/20230726/YmFubmVyX2JnLjE2OTAzNDQ4NjE0Mjc=.png) center center no-repeat;
    background-size: 100% 100%;
  }
  .rolling {
    width: 667PX;
    display: flex;
    margin: 0 50PX;
    flex-direction: column;
    align-items: center;
    margin-bottom: 300PX;
    h2{
      color: #fff;
      font-size: 38PX;
    }
  }
}
</style>
